//@ts-ignore
import { reportMessage } from '../raven-message';
import { getIsStorageAvailable } from './get-is-storage-available';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFromLocalStorage(key: string, defaultValue: any) {
    const isLocalStorageAvailable = getIsStorageAvailable();

    if (typeof window !== 'undefined' && isLocalStorageAvailable) {
        return window.localStorage.getItem(key);
    }

    return defaultValue;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setToLocalStorage(key: string, value: any) {
    const isLocalStorageAvailable = getIsStorageAvailable();

    if (typeof window !== 'undefined' && isLocalStorageAvailable) {
        window.localStorage.setItem(key, value);
    } else if (!isLocalStorageAvailable) {
        reportMessage('Local storage is unavailable');
    }
}

export function removeFromLocalStorage(key: string) {
    const isLocalStorageAvailable = getIsStorageAvailable();

    if (typeof window !== 'undefined' && isLocalStorageAvailable) {
        window.localStorage.removeItem(key);
    } else if (!isLocalStorageAvailable) {
        reportMessage('Local storage is unavailable');
    }
}
